import { Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';
import { Store } from '@ngxs/store';
import { ScopeState } from './scope.state';
import { slugify } from '@core/shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
const SCOPE_CLASS_PREFIX = 'scope-';
export let ScopeBodyClassService = /*#__PURE__*/(() => {
  class ScopeBodyClassService {
    constructor(doc, store, rendererFactory) {
      // as we are in a service injection of Renderer2 is not possible directly.
      // but we can inject RendererFactory2 and create one by ourselves, as Angular does it e.g. in serviceWorker.
      this.renderer = rendererFactory.createRenderer(null, null);
      this.body = doc.body;
      store.select(ScopeState.scope).subscribe(scope => {
        this.assignNewScope(scope);
      });
    }
    assignNewScope(scope) {
      // sanitize scope to make sure it does only contain allowed css-classname chars
      const sanitizedScope = slugify(scope);
      if (this.prevScope) {
        this.renderer.removeClass(this.body, SCOPE_CLASS_PREFIX + this.prevScope);
      }
      this.renderer.addClass(this.body, SCOPE_CLASS_PREFIX + sanitizedScope);
      this.prevScope = sanitizedScope;
    }
    static {
      this.ɵfac = function ScopeBodyClassService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScopeBodyClassService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i1.Store), i0.ɵɵinject(i0.RendererFactory2));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ScopeBodyClassService,
        factory: ScopeBodyClassService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ScopeBodyClassService;
})();